import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorServiceService } from '../services/error-service.service';
import { IServiceError } from '../interfaces';
import { getErrorMessageByCode } from 'src/app/utils';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly cookieService = inject(CookieService);
  private readonly errorServiceService = inject(ErrorServiceService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status) {
          const lang = this.cookieService.get('UasLang');

          const serverMessage = err.error?.message || err.error?.Message || err.error?.title;

          const error: IServiceError = {
            error: true,
            errorStatus: err.status,
            messageError:
              getErrorMessageByCode(err.status, lang) || serverMessage,
          };

          console.error(
            `ERROR WITH REQUEST:\n Error: [${serverMessage}];\n Status code: [${err.status}];`
          );

          this.errorServiceService.callErrorPopup(error);
        }

        const error =
          err.error || err.error?.message || err.statusText || err.error?.title;

        return throwError(() => new Error(error));
      })
    );
  }
}
